import { IModalStatus } from '@/type/detail';
import { SET_MODAL_STATUS } from './const';

export const setModalStatus = (payload: IModalStatus) => ({
  type: SET_MODAL_STATUS,
  payload,
});
